/**
 * Preprint callout.
 *
 * Converted verbatim from `public/index.html:475-506`.
 */

const PaperSection = () => (
  <section id="paper" className="paper-section">
    <div className="paper-content">
      <div className="paper-icon">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
      </div>
      <h2 className="paper-title">ICLR MLGenX 2026</h2>
      <p className="paper-paper-title">
        A Conversational Multi-Agent AI Framework for Integrated Multi-Omics
        Analysis and Biomedical Discovery
      </p>
      <p className="paper-description">
        Our accepted workshop paper presents LungChat as a conversational
        multi-agent framework for integrated multi-omics analysis and biomedical
        discovery. The paper describes how a stateful supervisor coordinates
        specialist agents, validated analytical tools, curated lung omics
        datasets, and DART for cell-type-resolved therapeutic prioritization.
      </p>
      <a
        href="/paper/iclr-2026"
        className="btn-paper"
        target="_blank"
        rel="noopener"
      >
        Read the Paper
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
          <polyline points="15 3 21 3 21 9" />
          <line x1="10" y1="14" x2="21" y2="3" />
        </svg>
      </a>
    </div>
  </section>
);

export default PaperSection;
